export const getPercentage = (percentage?: number | string | null) =>
  isNaN(Number(percentage)) ? 0 : Number(percentage);
